import { Injectable, inject } from '@angular/core';
import { AppData } from '@app/shared/models/appdata.model';
import {
  BattlecardsOperator,
  BattlecardsServiceCategory,
  BattlecardsOfferingRequest,
  BattlecardsOfferingResponse,
  BattlecardsRecommendedOffering,
} from '@app/support/models/battlecards/battlecards.model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BattlecardsService {
  private http = inject(HttpClient);
  private appData = inject(AppData);

  private apiUrl = `${this.appData.apiUrl}/api/v1`;

  getOperators(): Observable<BattlecardsOperator[]> {
    const url = `${this.apiUrl}/battlecards/operators`;
    return this.http.get<BattlecardsOperator[]>(url);
  }

  getExternalOfferings(request: BattlecardsOfferingRequest): Observable<BattlecardsOfferingResponse> {
    let params = new HttpParams().set('currentPage', request.currentPage.toString()).set('take', request.take.toString());

    if (request.operators) {
      params = params.set('operators', request.operators.join(','));
    }
    if (request.ageCategories) {
      params = params.set('ageCategories', request.ageCategories.join(','));
    }
    if (request.serviceCategories) {
      params = params.set('serviceCategories', request.serviceCategories.join(','));
    }

    const url = `${this.apiUrl}/battlecards/external/subscription-offerings`;

    return this.http.get<BattlecardsOfferingResponse>(url, { params });
  }

  getInternalOfferings(request: BattlecardsOfferingRequest): Observable<BattlecardsOfferingResponse> {
    let params = new HttpParams().set('currentPage', request.currentPage.toString()).set('take', request.take.toString());
    if (request.ageCategories) {
      params = params.set('ageCategories', request.ageCategories.join(','));
    }

    const url = `${this.apiUrl}/battlecards/internal/subscription-offerings`;

    return this.http.get<BattlecardsOfferingResponse>(url, { params });
  }

  getServiceCategories(): Observable<BattlecardsServiceCategory[]> {
    const url = `${this.apiUrl}/battlecards/servicecategories`;
    return this.http.get<BattlecardsServiceCategory[]>(url);
  }

  getRecommendedOfferings(offeringId: string): Observable<BattlecardsRecommendedOffering[]> {
    const url = `${this.apiUrl}/battlecards/recommended-offerings?competitorOfferingId=${offeringId}`;
    return this.http.get<BattlecardsRecommendedOffering[]>(url);
  }
}
